// extracted by mini-css-extract-plugin
export default {"news":"index_news_qrI6V","title":"index_title_8H-H-","subTitle":"index_subTitle_q6s2S"};